<div class="merge-task-table-frame">
  <div class="table-header">
    <div class="header-left">
      <span class="route-label"><b>Route- {{ routeName }}</b></span>
      <ng-container *ngIf="
        (selectionMode === 'single' && selectionSummary && selectionSummary.length === 1)
        || (currentStep === MergeTaskStep.Preview || currentStep === MergeTaskStep.Result)
      ">
        <span class="selected-count">
          1 task selected
        </span>
        <p-tag value="Target Task" class="primary-outline-chip"  />
      </ng-container>
      <ng-container *ngIf="selectionMode === 'multiple'">
        <span class="selected-count" *ngIf="selectedCount > 0">
          {{ selectedCount }} {{ selectedCount === 1 ? 'task' : 'tasks' }} selected
        </span>
        <p-tag *ngIf="selectedCount > 0"
          [value]="allSelectedValidForMerge ? 'Valid for Merge' : ''"
           class="primary-outline-chip" />
      </ng-container>
    </div>
    <div class="header-right">
      <div class="position-relative">
        <input class="form-control form-control-sm search-input" type="text"
          [(ngModel)]="searchText" (input)="onSearch($event)" placeholder="Search" />
        <button *ngIf="searchText && searchText.length > 0" class="clear-icon"
          (click)="clearSearch()" type="button">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Task Table -->
  <div class="table-container">
    <p-table #taskTable
    [value]="tasks"
    [(selection)]="selectedTasks"
    (selectionChange)="onSelectionChange()"
    dataKey="task_id"
    [scrollable]="true"
    scrollHeight="flex"
    [rowHover]="true"
    [loading]="loading"
    [globalFilterFields]="['task_id', 'task_point_name', 'address', 'task_type', 'task_state', 'item_count', 'task_time_window']"
    styleClass="p-datatable-sm p-datatable-striped"
    [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}"
    [selectionMode]="selectionMode === 'single' ? 'single' : undefined"
  >
    <ng-template pTemplate="loadingicon">
      <i class="pi pi-spin pi-spinner fs-2 fw-bold"></i>
    </ng-template>
    <ng-template pTemplate="header">
      <tr style="width: 100%;">
        <th scope="col" style="width: 2.7rem; padding-left: 0.6rem; height: 30px;">
          <p-tableHeaderCheckbox *ngIf="selectionMode === 'multiple'"></p-tableHeaderCheckbox>
        </th>
        <th pSortableColumn="task_point_name" scope="col">Task Point <p-sortIcon field="task_point_name"></p-sortIcon></th>
        <th pSortableColumn="address" scope="col">Address <p-sortIcon field="address"></p-sortIcon></th>
        <th pSortableColumn="task_type" scope="col">Type <p-sortIcon field="task_type"></p-sortIcon></th>
        <th pSortableColumn="item_count" scope="col">Items <p-sortIcon field="item_count"></p-sortIcon></th>
        <th pSortableColumn="task_time_window" scope="col">Time Window <p-sortIcon field="task_time_window"></p-sortIcon></th>
        <th pSortableColumn="task_state" scope="col">State <p-sortIcon field="task_state"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-task let-rowIndex="rowIndex">
      <tr>
        <td style="width: 2.7rem">
          <p-tableCheckbox *ngIf="selectionMode === 'multiple'" [value]="task" [disabled]="isSelectionDisabled ? isSelectionDisabled(task) : false"></p-tableCheckbox>
          <p-tableRadioButton *ngIf="selectionMode === 'single'" [value]="task" [disabled]="isSelectionDisabled ? isSelectionDisabled(task) : false"></p-tableRadioButton>
        </td>
        <td class="wrapRowData" [pTooltip]="task.task_point_name" tooltipPosition="bottom">{{ task.task_point_name }}</td>
        <td class="wrapRowData" [pTooltip]="task.address" tooltipPosition="bottom">{{ task.address }}</td>
        <td class="wrapRowData">{{ task.task_type }}</td>
        <td>{{ task.item_count }}</td>
        <td class="wrapRowData">{{ task.task_time_window }}</td>
        <td class="wrapRowData">
          <ng-container *ngIf="currentStep === MergeTaskStep.Preview || currentStep === MergeTaskStep.Result">
            <p-tag *ngIf="rowIndex === 0" [value]="task.task_state" [styleClass]="getTaskStateClass(task.task_state)"></p-tag>
            <p-tag *ngIf="rowIndex > 0"  [value]="'Closed - Merge'" [styleClass]="getTaskStateClass('closed-merge')"></p-tag>
          </ng-container>
          <ng-container *ngIf="currentStep !== MergeTaskStep.Preview && currentStep !== MergeTaskStep.Result">
            <p-tag [value]="task.task_state" [styleClass]="getTaskStateClass(task.task_state)" />
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">
          <div class="text-center no-record-label">No tasks found.</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  </div>
</div>
